<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} {{aLang.trs_title}}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item :label="aLang.trs_fullname" prop>
                      <el-input
                        v-model="mData.tableRules.dataSearch.value['ho_ten.ho_ten']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.trs_email" prop>
                      <el-input v-model="mData.tableRules.dataSearch.value['email']" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.trs_phone" prop>
                      <el-input
                        type="text"
                        v-model="mData.tableRules.dataSearch.value['dien_thoai']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.trs_card_number" prop>
                      <el-input
                        type="text"
                        v-model="mData.tableRules.dataSearch.value['so_the']"
                        clearable              
                      ></el-input>
                    </el-form-item>
                  </b-col>                
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="4"></b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>             
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="ho_ten.ho_ten"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.trs_fullname"
            min-width="200"
          >
            <template slot-scope="scope">             
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail',scope.$index, scope.row)"
                :underline="false"
              >{{scope.row.ho_ten.ho_ten}}</el-link>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="so_the"
            :sortable="mData.tableRules.allowSorting"
            label="Số thẻ"
            width="200"
            align="center"
          ></el-table-column> -->
          <el-table-column
            :label="aLang.trs_card_number"
            width="150"
            align="right">
            <template slot-scope="scope" v-if="scope.row">
              {{scope.row.so_the && scope.row.so_the.slice(0,2) && scope.row.so_the.length == 11? 'Chưa có thông tin' : scope.row.so_the}}
            </template>
          </el-table-column>
          <el-table-column
            prop="gioi_tinh"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.trs_gender"
            width="150"
            align="center"
          ></el-table-column>

          <!-- <el-table-column
            prop="ngay_sinh.ngay_sinh"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.trs_bod"
            :formatter="fn_formatterDate"
            align="center"
            width="120"
          >
            <!-- <template slot-scope="scope" v-if="scope.row">
              {{scope.row.ngay_sinh.ngay_sinh ? scope.row.ngay_sinh.ngay_sinh : "" }}
            </template>   -->
          </el-table-column> -->
          <el-table-column
            prop="email"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.trs_email"
            width="120"
          ></el-table-column>
          <!-- <el-table-column
            prop="dien_thoai"
            :sortable="mData.tableRules.allowSorting"
            label="Điện Thoại"
            width="120"
            align="right"
          ></el-table-column>        -->
          <el-table-column
              :label="aLang.trs_phone"
              width="150"
              align="right">
            <template slot-scope="scope" v-if="scope.row">
              {{
                scope.row.so_the && scope.row.so_the.slice(0,2) == "84" && scope.row.so_the.length == 11 ? 
                scope.row.so_the : 
                (scope.row.dien_thoai ? scope.row.dien_thoai : "Chưa có thông tin")}}
            </template>
          </el-table-column>


          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>            
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import KhachDuLichModel from "./KhachDuLichModel";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";

export default {
  data() {
    return {
      aRole:MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "KhachDuLich", //requied
        tableRules:  MethodService.copyObject(KhachDuLichModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listCongTyLuHanh: []
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        }).catch(() => {});
      }

      let res = await KhachDuLichApi.list(dataFilter);
      console.log("res.result",res.result);
      this.mData.tableRules.data = this.changeData(res.result);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {
      $.each(data, (index, item) => {
        if(item.ho_ten && item.ho_ten.ho_ten && item.ho_ten.ho_ten.trim() != ""){
          item.ho_ten.ho_ten = item.ho_ten.ho_ten; 
        }else{
          item.ho_ten ={
            ho_ten : "Chưa có thông tin" 
          } 
        }
        if(item.email){
          item.email = item.email;
        }else{
          item.email = "Chưa có thông tin";
        }

        if (item.gioi_tinh != undefined) {
          let gt = DataService.gioiTinh.find(element => {
            return element.id == item.gioi_tinh;
          });
          if (gt) {
            item.gioi_tinh = gt.text;
          }
        }else{
          item.gioi_tinh = "Chưa có thông tin";
        }

        if (item.ngay_sinh != undefined) {
          item.ngay_sinh.ngay_sinh = new Date(
            item.ngay_sinh.nam,
            item.ngay_sinh.thang - 1,
            item.ngay_sinh.ngay
          ).toUTCString();          
        }else{
          item.ngay_sinh = {};
          item.ngay_sinh.ngay_sinh = "Chưa có thông tin";
        }
      });
      return data;
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await KhachDuLichApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await KhachDuLichApi.disable(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      if(this.mData.tableRules.dataSearch.value['ho_ten.ho_ten']){
        this.mData.tableRules.dataSearch.value['ho_ten.ho_ten'] = this.mData.tableRules.dataSearch.value['ho_ten.ho_ten'].trim();
      }
      if(this.mData.tableRules.dataSearch.value['email']){
        this.mData.tableRules.dataSearch.value['email'] = this.mData.tableRules.dataSearch.value['email'].trim();
      }
      if(this.mData.tableRules.dataSearch.value['dien_thoai']){
        this.mData.tableRules.dataSearch.value['dien_thoai'] = this.mData.tableRules.dataSearch.value['dien_thoai'].trim();
      }
      if(this.mData.tableRules.dataSearch.value['so_the']){
        this.mData.tableRules.dataSearch.value['so_the'] = this.mData.tableRules.dataSearch.value['so_the'].trim();
      }

      this.$refs["myForm"].validate(async valid => {
        if (valid) {          
          this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));
          let m = this.mData.tableRules.filters.match(/dien_thoai(%3D|=)([^&|]*)/g);
          if(
            this.mData.tableRules.dataSearch.value['dien_thoai'] &&
            this.mData.tableRules.dataSearch.value['dien_thoai'].substr(0,1) == "0" &&
            this.mData.tableRules.dataSearch.value['dien_thoai'].length == 10
          ){
            if(m){
              this.mData.tableRules.filters = this.mData.tableRules.filters.replace(m[0] , m[0]+"|dien_thoai="+this.mData.tableRules.dataSearch.value['dien_thoai'].replace(/^\d{1}/,'84'));
            }
          }else if(
            this.mData.tableRules.dataSearch.value['dien_thoai'] &&
            this.mData.tableRules.dataSearch.value['dien_thoai'].substr(0,2) == "84" &&
            this.mData.tableRules.dataSearch.value['dien_thoai'].length == 11
          ){
            if(m){
              this.mData.tableRules.filters = this.mData.tableRules.filters.replace(m[0] , m[0]+"|dien_thoai="+this.mData.tableRules.dataSearch.value['dien_thoai'].replace(/^\d{2}/,'0'));
            }
          }
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        console.log("this.mData.tableRules.filters",this.mData.tableRules.filters);
        let m = this.mData.tableRules.filters.match(/\|?dien_thoai=([^&\|]*)/g);
        if(m){
          this.mData.tableRules.filters = this.mData.tableRules.filters.replace(m[1],'');
        }
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
        console.log("this.mData.tableRules.dataSearch.value",this.mData.tableRules.dataSearch.value);
        this.fn_search();
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
    fn_search(){
      this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));
      let m = this.mData.tableRules.filters.match(/dien_thoai(%3D|=)([^&|]*)/g);
      if(
        this.mData.tableRules.dataSearch.value['dien_thoai'].substr(0,1) == "0" &&
        this.mData.tableRules.dataSearch.value['dien_thoai'].length == 10
      ){
        if(m){
          this.mData.tableRules.filters = this.mData.tableRules.filters.replace(m[0] , m[0]+"|dien_thoai="+this.mData.tableRules.dataSearch.value['dien_thoai'].replace(/^\d{1}/,'84'));
        }
      }else if(
        this.mData.tableRules.dataSearch.value['dien_thoai'].substr(0,2) == "84" &&
        this.mData.tableRules.dataSearch.value['dien_thoai'].length == 11
      ){
        if(m){
          this.mData.tableRules.filters = this.mData.tableRules.filters.replace(m[0] , m[0]+"|dien_thoai="+this.mData.tableRules.dataSearch.value['dien_thoai'].replace(/^\d{2}/,'0'));
        }
      }
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.sort = "";
      this.fn_initTable();
    }
  },

  //run after render view
  created() {
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
